//
//
//
//
//
//

import HeatMap from './components/HeatMap.vue'

export default {
  name: 'app',
  components: {
      HeatMap
  }
}
